<nav class="main-header navbar navbar-expand navbar-white navbar-light">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" (click)="toggleMenuSidebar.emit()" role="button"
        ><i class="fas fa-bars"></i
      ></a>
    </li>
    <!-- <li class="nav-item d-none d-sm-inline-block">
      <a [routerLink]="['/']" class="nav-link">Home</a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a [routerLink]="['/blank']" class="nav-link">Contact</a>
    </li> -->
  </ul>
  <!-- <form class="form-inline ml-3" [formGroup]="searchForm">
    <div class="input-group input-group-sm">
      <input
        class="form-control form-control-navbar"
        type="search"
        placeholder="Search"
        aria-label="Search"
      />
      <div class="input-group-append">
        <button class="btn btn-navbar" type="submit">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </form> -->
  <div class="navbar-nav ml-auto navbar-custom-menu">
    <li class="dropdown user user-menu">
      <a href="#" class="dropdown-toggle" data-toggle="dropdown">
        <img src="/assets/images/avatar.png" class="user-image" />
        <div class="d-none d-sm-inline-block">
          {{ account.tenantName }}<br />
          <small>{{ account.familyName }} {{ account.firstName }}</small>
        </div>
      </a>
      <div class="dropdown-menu">
        <div class="dropdown-divider"></div>
        <a  [routerLink]="['/password']" class="dropdown-item">Password change</a>
        <div class="dropdown-divider"></div>
        <a (click)="signout()" class="dropdown-item" href="#">Signout</a>
      </div>
    </li>
  </div>
  <!-- 
  <ul class="navbar-nav ml-auto">
    <li class="nav-item dropdown user-menu">
      <a
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        (click)="toggleDropdownMenu()"
      >
        <img
          [src]="account.logoImage"
          class="user-image img-circle elevation-2"
        />
      </a>

      <ul #dropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
        <li class="user-header bg-primary">
          <img [src]="user.image" class="img-circle elevation-2" alt="User Image" />
    
          <p>
            Alexander Pierce - Web Developer
            <small>Member since Nov. 2012</small>
          </p>
        </li>
        <li class="user-body">
          <div class="row">
            <div class="col-4 text-center">
              <a href="#">Followers</a>
            </div>
            <div class="col-4 text-center">
              <a href="#">Sales</a>
            </div>
            <div class="col-4 text-center">
              <a href="#">Friends</a>
            </div>
          </div>
        </li>
        <li class="user-footer">
          <a [routerLink]="['/profile']" class="btn btn-default btn-flat">
            Profile
          </a>
          <a (click)="logout()" class="btn btn-default btn-flat float-right"
            >Sign out</a
          >
        </li>
      </ul> -->
  <!-- </li> -->

  <!-- <app-messages-dropdown-menu></app-messages-dropdown-menu>
    <app-notifications-dropdown-menu></app-notifications-dropdown-menu>
    <app-user-dropdown-menu></app-user-dropdown-menu> -->
  <!-- <li class="nav-item">
      <a
        class="nav-link"
        data-widget="control-sidebar"
        data-slide="true"
        href="#"
        role="button"
      >
        <i class="fas fa-th-large"></i>
      </a>
    </li> -->
  <!-- </ul> -->
</nav>
